import axios from 'axios';
import Cookies from 'universal-cookie';

const SigliveServiceV1 = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL ?? ''}api/v1`,
});

SigliveServiceV1.interceptors.request.use(
  (config) => {
    const cookies = new Cookies();
    const token = cookies.get('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

SigliveServiceV1.interceptors.response.use(
  (response) => response,
  (error) => {
    const cookies = new Cookies();
    const token = cookies.get('token');
    const errorResponse = error?.response?.data?.errors?.[0];

    if (errorResponse?.code === 401 && token && !window.location.pathname.includes('/forbidden')) {
      const reason = errorResponse?.type === 'EXPIRED_TOKEN' ? '?reason=expired' : '';
      window.location.href = `/forbidden${reason}`;
    }
    return Promise.reject(error);
  },
);

export default SigliveServiceV1;
